import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import About from "@/pages/home/components/About";
import Features from "@/pages/home/components/Features";
import AppSection from "@/pages/home/components/AppSection";
import Clients from "@/pages/home/components/Clients";
import Membership from "@/pages/home/components/Membership";
import Vip from "@/pages/home/components/Vip";
import Danmaku from "@/pages/home/components/Danmaku";
import Collections from "@/pages/home/components/Collections";
import Guide from "@/pages/home/components/Guide";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <About />
        <Features />
        <AppSection />
        <Clients />
        <Membership />
        <Vip />
        <Danmaku />
        <Collections />
        <Guide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}